/**
 * Maps order request type values to their display format
 */
export const mapOrderRequestType = (type) => {
  switch (type) {
    case "purchase-request":
      return "PURCHASE_REQUEST";
    case "pre-order":
      return "PREORDER";
    default:
      return type;
  }
};

/**
 * Maps vehicle source values to their display format
 */
export const mapVehicleSource = (source) => {
  switch (source) {
    case "in-stock":
      return "In stock";
    case "pipeline":
      return "Pipeline";
    case "in-transit":
      return "In transit";
    case "retail-order":
      return "Retail Order";
    default:
      return source;
  }
};

/**
 * Maps order status values to their display format
 */
export const mapOrderStatus = (status) => {
  switch (status) {
    case "created":
      return "CREATED";
    case "accepted":
      return "ACCEPTED";
    case "canceled":
      return "CANCELED";
    default:
      return status;
  }
};

/**
 * Maps array elements using provided mapping function, returns empty array for empty/undefined input
 */
export const getFilteredArray = (selectedArray, mapFn) => {
  return selectedArray?.length > 0 ? selectedArray.map(mapFn) : [];
};

export const filterLincolnOrders = (orders, filters) => {
  const normalize = (value) =>
    String(value || "")
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "");
  const matches = (values, value) =>
    !values?.length ||
    values.some((selected) => normalize(selected) === normalize(value));
  const actionRequiredOnly = filters.actionRequired?.includes("yes");
  return orders.filter(
    (order) =>
      (!actionRequiredOnly || order.isActionRequired === true) &&
      matches(filters.orderRequestType, order.orderType) &&
      matches(filters.vehicleSource, order.source) &&
      matches(
        filters.orderStatus,
        order.orderStatus === "Cancelled" ? "Canceled" : order.orderStatus
      )
  );
};
